import { UserSetting } from '../../autogenerated/data-contracts';

const useUserSettingsMockData: UserSetting[] = [];

export default useUserSettingsMockData;
